module.exports = __webpack_public_path__ + "static/img/Chad_Wingard_desktop.b8b2de6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Chad_Wingard_desktop.jpg
// module id = Xe9H
// module chunks = 0